import * as React from "react"

import { useContentSidebarStore } from "@/stores/content-sidebar-store"

const MOBILE_BREAKPOINT = 1024

type UseIsMobileProps = {
  breakpoint?: number
  includeContentSidebarOpen?: boolean
}

export function useIsMobile({
  breakpoint = MOBILE_BREAKPOINT,
  includeContentSidebarOpen = true,
}: UseIsMobileProps = {}) {
  const isContentSidebarOpen = useContentSidebarStore((state) => state.isOpen)
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < breakpoint)
    }
    mql.addEventListener("change", onChange)
    setIsMobile(window.innerWidth < breakpoint)
    return () => mql.removeEventListener("change", onChange)
  }, [breakpoint])

  return !!isMobile || (includeContentSidebarOpen && isContentSidebarOpen)
}
